import AskPostDataModal from './askPostModal';

export default AskPostDataModal;